"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.manageSettlementsLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const access_1 = require("../../../../common/constants/access");
const appConstants_1 = require("../../../constants/appConstants");
const companyQuery_1 = require("../../../queries/companyQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const manageSettlementsLoader = async ({ queryClient, params, }) => {
    const logger = (0, pino_1.default)();
    const verifyUserAccessQuery = (0, userQuery_1.getVerifyUserAccessQuery)(access_1.composites.WRITE_COMPANY);
    const userData = await queryClient.ensureQueryData(userQuery_1.userQuery);
    const userRole = (0, userSelectors_1.isCompanyOrSupportAdmin)(userData.roles)
        ? appConstants_1.overviewConstants.COMPANY_ADMIN
        : userData.roles.find(role => role.securityGroupId === params.teamId)?.roleId || '';
    const hasAccess = await queryClient.ensureQueryData({
        queryKey: verifyUserAccessQuery.queryKey,
        queryFn: verifyUserAccessQuery.queryFn,
    });
    let companyFeatures;
    try {
        companyFeatures = await queryClient.ensureQueryData(companyQuery_1.companyFeaturesQuery);
    }
    catch (error) {
        logger.error(error);
    }
    const companyPropertiesData = await queryClient.ensureQueryData((0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    return {
        userRole,
        userData,
        hasAccess,
        settlements: [],
        companyFeatures,
        showReceiptUpload: companyFeatures.ENABLE_TRANSACTION_RECEIPT_UPLOAD,
        teamId: params.teamId,
        companyPropertiesData,
    };
};
exports.manageSettlementsLoader = manageSettlementsLoader;
